// extracted by mini-css-extract-plugin
module.exports = {"container":"container-v_container__10JQA"};